module.exports = __webpack_public_path__ + "img/9.bf68c0d9.png";